import { appConfig } from '../constants';
import { setRuntimeConfig } from './runtimeConfig';

export async function initRuntimeConfig(): Promise<void> {
  if (!appConfig.configUrl) return;
  try {
    const res = await fetch(appConfig.configUrl);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const config = (await res.json()) as {
      authAuthority?: string;
      authClientId?: string;
    };
    setRuntimeConfig(config);
  } catch {
    // fall back to static appConfig values
  }
}
